import { render } from "./qnaList.vue?vue&type=template&id=1e49a596&scoped=true&ts=true"
import script from "./qnaList.vue?vue&type=script&lang=ts&config=true"
export * from "./qnaList.vue?vue&type=script&lang=ts&config=true"

import "./qnaList.vue?vue&type=style&index=0&id=1e49a596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e49a596"]])

export default __exports__